import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/blog/article";
import BlogListPage from "../pages/blog/list";
import SpreadsheetPage from "../pages/spreadsheet/page";
import ReviewPage from "../pages/review/page";
import ShippingPage from "../pages/shipping/page";
import SafetyPage from "../pages/safety/page";
import GuidesPage from "../pages/guides/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },

  // Home (per language)
  { path: "/en", element: <Home /> },
  { path: "/en/", element: <Home /> },
  { path: "/fr", element: <Home /> },
  { path: "/fr/", element: <Home /> },
  { path: "/de", element: <Home /> },
  { path: "/de/", element: <Home /> },
  { path: "/da", element: <Home /> },
  { path: "/da/", element: <Home /> },

  // Spreadsheet Hub — category detail pages (must come BEFORE generic /:slug)
  { path: "/en/allchinabuy-spreadsheet/:slug/", element: <SpreadsheetPage /> },
  { path: "/fr/allchinabuy-spreadsheet/:slug/", element: <SpreadsheetPage /> },
  { path: "/de/allchinabuy-spreadsheet/:slug/", element: <SpreadsheetPage /> },
  { path: "/da/allchinabuy-spreadsheet/:slug/", element: <SpreadsheetPage /> },

  // Spreadsheet Hub — generic page
  { path: "/en/allchinabuy-spreadsheet", element: <SpreadsheetPage /> },
  { path: "/en/allchinabuy-spreadsheet/", element: <SpreadsheetPage /> },
  { path: "/fr/allchinabuy-spreadsheet", element: <SpreadsheetPage /> },
  { path: "/fr/allchinabuy-spreadsheet/", element: <SpreadsheetPage /> },
  { path: "/de/allchinabuy-spreadsheet", element: <SpreadsheetPage /> },
  { path: "/de/allchinabuy-spreadsheet/", element: <SpreadsheetPage /> },
  { path: "/da/allchinabuy-spreadsheet", element: <SpreadsheetPage /> },
  { path: "/da/allchinabuy-spreadsheet/", element: <SpreadsheetPage /> },

  // Shopping Guides
  { path: "/en/guides", element: <GuidesPage /> },
  { path: "/en/guides/", element: <GuidesPage /> },
  { path: "/fr/guides", element: <GuidesPage /> },
  { path: "/fr/guides/", element: <GuidesPage /> },
  { path: "/de/guides", element: <GuidesPage /> },
  { path: "/de/guides/", element: <GuidesPage /> },
  { path: "/da/guides", element: <GuidesPage /> },
  { path: "/da/guides/", element: <GuidesPage /> },

  // Review
  { path: "/en/review", element: <ReviewPage /> },
  { path: "/en/review/", element: <ReviewPage /> },
  { path: "/fr/review", element: <ReviewPage /> },
  { path: "/fr/review/", element: <ReviewPage /> },
  { path: "/de/review", element: <ReviewPage /> },
  { path: "/de/review/", element: <ReviewPage /> },
  { path: "/da/review", element: <ReviewPage /> },
  { path: "/da/review/", element: <ReviewPage /> },

  // Shipping Cost
  { path: "/en/shipping-cost", element: <ShippingPage /> },
  { path: "/en/shipping-cost/", element: <ShippingPage /> },
  { path: "/fr/shipping-cost", element: <ShippingPage /> },
  { path: "/fr/shipping-cost/", element: <ShippingPage /> },
  { path: "/de/shipping-cost", element: <ShippingPage /> },
  { path: "/de/shipping-cost/", element: <ShippingPage /> },
  { path: "/da/shipping-cost", element: <ShippingPage /> },
  { path: "/da/shipping-cost/", element: <ShippingPage /> },

  // Safety
  { path: "/en/safety", element: <SafetyPage /> },
  { path: "/en/safety/", element: <SafetyPage /> },
  { path: "/fr/safety", element: <SafetyPage /> },
  { path: "/fr/safety/", element: <SafetyPage /> },
  { path: "/de/safety", element: <SafetyPage /> },
  { path: "/de/safety/", element: <SafetyPage /> },
  { path: "/da/safety", element: <SafetyPage /> },
  { path: "/da/safety/", element: <SafetyPage /> },

  // Blog listing
  { path: "/en/blog", element: <BlogListPage /> },
  { path: "/en/blog/", element: <BlogListPage /> },
  { path: "/fr/blog", element: <BlogListPage /> },
  { path: "/fr/blog/", element: <BlogListPage /> },
  { path: "/de/blog", element: <BlogListPage /> },
  { path: "/de/blog/", element: <BlogListPage /> },
  { path: "/da/blog", element: <BlogListPage /> },
  { path: "/da/blog/", element: <BlogListPage /> },

  // Individual article pages
  { path: "/en/blog/:slug/", element: <ArticlePage /> },
  { path: "/fr/blog/:slug/", element: <ArticlePage /> },
  { path: "/de/blog/:slug/", element: <ArticlePage /> },
  { path: "/da/blog/:slug/", element: <ArticlePage /> },

  { path: "*", element: <NotFound /> },
];

export default routes;